import ReviewsSummary from './ReviewsSummary'

export default ReviewsSummary
